import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Column, TextButton, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { FollowUpSuggestions } from '~/components/ai/shared/FollowUpSuggestions/FollowUpSuggestions';
import { useIoContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import styles from './AnalystGuideAnswerMessage.module.scss';
export const GetAnalystGuideAnswerMessageTID = (parentTestId)=>getTestIds(parentTestId);
export const AnalystGuideAnswerMessage = (param)=>{
    let { part, messageId, onFollowUpClick } = param;
    const { AnalystGuideAnswerMessageTID } = useMemo(()=>GetAnalystGuideAnswerMessageTID(messageId), [
        messageId
    ]);
    const { t } = useLocaleKeys('analystAgent');
    const { browser } = useIoContext();
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 12,
        testId: AnalystGuideAnswerMessageTID.Root(),
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                testId: AnalystGuideAnswerMessageTID.Text(),
                showWhiteSpaces: true,
                applyMarkdownBold: true,
                children: part.text
            }),
            part.citations.length > 0 && /*#__PURE__*/ _jsxs(Column, {
                gap: 4,
                testId: AnalystGuideAnswerMessageTID.Sources(),
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        testId: AnalystGuideAnswerMessageTID.SourcesHeading(),
                        variant: "paragraph2",
                        weight: "bold",
                        skin: "secondary",
                        children: t.guideAnswer.sources()
                    }),
                    part.citations.map((citation, idx)=>/*#__PURE__*/ _jsx(TextButton, {
                            className: styles.sourceLink,
                            variant: "paragraph2",
                            weight: "normal",
                            testId: AnalystGuideAnswerMessageTID.SourceLink(idx),
                            bi: {
                                name: 'guide_citation_link',
                                data: {
                                    topic: citation.topic,
                                    url: citation.url
                                }
                            },
                            onClick: ()=>browser.openNewTab(citation.url),
                            children: citation.title
                        }, citation.url))
                ]
            }),
            part.followUp != null && /*#__PURE__*/ _jsx(FollowUpSuggestions, {
                followUp: part.followUp,
                showSuggestions: true,
                biName: "guide_followup_suggestion",
                onSuggestionClick: onFollowUpClick != null ? (suggestion)=>onFollowUpClick(suggestion.label) : undefined,
                testIds: {
                    FollowUp: AnalystGuideAnswerMessageTID.FollowUp,
                    FollowUpText: AnalystGuideAnswerMessageTID.FollowUpText,
                    FollowUpSuggestions: AnalystGuideAnswerMessageTID.FollowUpSuggestions,
                    FollowUpSuggestion: AnalystGuideAnswerMessageTID.FollowUpSuggestion
                }
            })
        ]
    });
};
